const resources = {
    getTheseBeforeGone: 'Get These Before They’re Gone'

};

export default function getResource(label) {
    return resources[label];
}
